import { Chip, FormControlLabel, Popper, styled } from "@mui/material";

export const CheckboxLabel = styled(FormControlLabel)(({ theme }) => ({
  "& .MuiFormControlLabel-label": {
    paddingLeft: theme.spacing(1),
  },
}));

export const AlignedPopper = styled(Popper)(({ theme }) => ({
  // the popper is slightly mis-aligned
  marginLeft: theme.spacing(0.125),
  marginTop: theme.spacing(-0.5),
}));

export const Tag = styled(Chip)(({ theme }) => ({
  margin: theme.spacing(0.5),
})) as typeof Chip;
